import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, Result, useDataProvider, Api, callApi, DataContext, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDSelect from "@cloudpremise/portal_core/src/themes/mui/components/MDSelect";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormLabel from '@mui/material/FormLabel';

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { Account } from "../types";

import "../styles/uiapi.scss";

const UIApi = (props) => {
    const dataProvider = useContext(DataContext);
    let defaultState = {
        Id: '',
        expandedPanels: {},
        layout: null,
        objectInfo: null,
        successMessage: null
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const [ authorized, authType ] = useAuthProvider();
    const navigate = useNavigate();

    const objectType = "Account";
    const layoutRecord: Account = {
        sObjectTypeName: objectType,
        url: "/ui-api/layout/"+objectType+"?mode=create"
    }
    const record: Account = {
        sObjectTypeName: objectType,
        url: "/ui-api/object-info/"+objectType
    }
    let layout = null;
    let objectInfo = null;
    const [loading] = useDataProvider(layoutRecord, {
        "provider": "salesforceapi"
    }, false, (data: any) => {
        layout = data;
        const newState = getFieldsState(layout, objectInfo);
        setState({
            layout: layout,
            ...newState
        });
    });

    useDataProvider(record, {
        "provider": "salesforceapi"
    }, false, (data: any) => {
        objectInfo = data;
        const newState = getFieldsState(layout, objectInfo);
        setState({
            objectInfo: objectInfo,
            ...newState
        });
    });

    React.useEffect(() => {
        if(authorized && (authType !== "salesforce")){
            return navigate("/auth-not-supported", { replace: true });
        }
    });
    function togglePanel(name){
        setState({
            expandedPanels: {
                ...state.expandedPanels,
                [name]: !state.expandedPanels[name],
            },
        });
    }
    function loadPicklists(){
        let url = "/ui-api/object-info/"+objectType+"/picklist-values/012000000000000AAA";
        Api.standardApi(url).then((response: any) => {
            let newState = {};
            if(typeof(response) === "object" && response.hasOwnProperty("picklistFieldValues")){
                for(const key in response.picklistFieldValues){
                    newState[key+"PicklistValues"] = response.picklistFieldValues[key].values;
                }
            }
            setState(newState);
        }).catch(err => {
            setState({
                errorMessage: err.message
            });
        });
    }
    function loadReferencePicklists(field, layoutComponent){
        const referenceInfo = field.referenceToInfos[0];
        let url = "/sobjects/"+referenceInfo.apiName;
        Api.standardApi(url).then((response: any) => {
            let newState = {};
            let items = [];
            response.recentItems.map((item) => {
                items.push({
                    Id: item.Id,
                    label: item.Name
                });
                return null;
            });
            newState[layoutComponent.apiName+"PicklistValues"] = items;
            setState(newState);
        }).catch(err => {
            setState({
                errorMessage: err.message
            });
        });
    }
    function getFieldsState(layout, objectInfo){
        let newState = {};
        if(layout === null || objectInfo === null){
            return newState;
        }
        const fields = objectInfo.fields;
        layout.sections.map((section, key) => {
            section.layoutRows.map((row) => {
                row.layoutItems.map((layoutItem) => {
                    const layoutComponent = layoutItem.layoutComponents[0];
                    let apiName = layoutComponent.apiName;
                    let field = null;
                    if(layoutComponent.componentType === 'Field' && fields.hasOwnProperty(apiName)){
                        field = fields[apiName];
                    }
                    if(field === null){
                        return null;
                    }
                    let value = "";
                    // if(props.item !== null && props.item.hasOwnProperty(apiName)){
                    //     value = props.item[apiName];
                    // }
                    newState[apiName] = value;
                    if(field.dataType === "PICKLIST" || field.dataType === "Picklist" || field.dataType === "Reference"){
                        newState[apiName+"PicklistValues"] = [];
                        newState[apiName+"Selection"] = [];
                    }
                    if(field.dataType === "Reference"){
                        loadReferencePicklists(field, layoutComponent);
                    }
                    return null;
                });
                return null;
            });
            return null;
        });
        loadPicklists();
        return newState;
    }
    function renderLayout(){
        const { layout, objectInfo } = state;
        if(layout === null || objectInfo === null){
            return null;
        }
        const fields = objectInfo.fields;
        return (
            layout.sections.map((section, key) => {
                return (
                    <Accordion
                        id={"accordion-accordion"+section.id}
                        expanded={((!!state.expandedPanels["panel"+section.id]) || (section.collapsible === false))}
                        onChange={() => togglePanel("panel"+section.id)}
                        key={key}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id={"panel-panel"+section.id}
                        >
                            <Typography>
                                {section.heading}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {
                                section.layoutRows.map((row, rowKey) => {
                                    return (
                                        <Grid container justifyContent="flex-start" alignItems="flex-start" key={rowKey} spacing={2}>
                                            {
                                                row.layoutItems.map((layoutItem, layoutkey) => {
                                                    const layoutComponent = layoutItem.layoutComponents[0];
                                                    let field = null;
                                                    if(layoutComponent.componentType === 'Field' && fields.hasOwnProperty(layoutComponent.apiName)){
                                                        field = fields[layoutComponent.apiName];
                                                    }
                                                    let itemCount = row.layoutItems.length;

                                                    return (
                                                        <Grid item xs={12} md={(itemCount > 1 ? (12/itemCount) : 6)} lg={(itemCount > 1 ? (12/itemCount) : 6)} key={layoutkey}>
                                                            <MDBox mb={3}>
                                                                {
                                                                    layoutComponent.componentType === "EmptySpace" ?
                                                                        <div>&nbsp;</div>
                                                                    :
                                                                        (!layoutItem.editableForNew || !layoutItem.editableForUpdate) ?
                                                                            <FormLabel sx={{fontSize: "15px"}}>{layoutItem.label}</FormLabel>
                                                                            // <div className="slds-form-element slds-m-bottom_x-small slds-m-right_small">
                                                                            //     <label className="slds-form-element__label" htmlFor="settings-owner"></label>
                                                                            //     <div className="slds-form-element__control slds-input-has-icon slds-input-has-icon_right">
                                                                                    
                                                                            //     </div>
                                                                            // </div>
                                                                        :
                                                                        renderField(layoutItem, field)
                                                                }
                                                            </MDBox>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    )
                                })
                            }
                        </AccordionDetails>
                    </Accordion>
                )
            })
        )
    }
    function handleChange(event, name){
        const value = event.target.value;
        setState({
            [name]: value,
            hasModifiedFields: true
        });
    }
    function onSelectChange(newValue, name){
        setState({
            [name]: (newValue ? newValue.label : ''),
            [name+"Selection"]: (newValue ? newValue.id : '')
        });
    }
    function getPicklist(field, layoutComponent){
        let picklists = state[layoutComponent.apiName+"PicklistValues"];
        // const isDependentPicklist = field.isDependentPicklist;
        // if(isDependentPicklist && field.controllingPicklist.length > 0){
        //     const fieldValue = state[field.controllingPicklist];
        //     if(fieldValue && picklists.hasOwnProperty(fieldValue)){
        //         picklists = picklists[fieldValue];
        //     }
        // }

        if(!Array.isArray(picklists)){
            return [];
        }
        let list = [{
            id: '',
            label: '--None--'
        }];
        if(field.dataType === 'Reference'){
            list = [];
        }
        picklists.map(item => {
            // Handle for dependent fields
            if(typeof(item) === "string"){
                item = {
                    label: item
                }
            }
            let id = item.label;
            if(item.hasOwnProperty("Id")){
                id = item.Id;
            }
            list.push({
                id: id,
                label: item.label
            });
            return null;
        });
        return list;
    }
    function renderField(layoutItem, field){
        if(field === null){
            return null;
        }
        const layoutComponent = layoutItem.layoutComponents[0];
        let fieldElement = null;
        const fieldOptions = getPicklist(field, layoutComponent);
        const fieldValue = state[layoutComponent.apiName];
        // const isDependentPicklist = field.isDependentPicklist;
        // if(isDependentPicklist && field.controllingPicklist.length > 0){
        //     const fieldValue = state[field.controllingPicklist];
        //     if(!fieldValue || fieldValue.length <= 0){
        //         return null;
        //     }
        // }
        switch(field.dataType){
            case 'STRING':
            case 'EMAIL':
            case 'String':
            case 'Email':
                let inputType = 'text';
                if(field.dataType === 'EMAIL' || field.dataType === 'Email'){
                    inputType = 'email';
                }
                fieldElement = (
                    <MDInput
                        label={layoutItem.label}
                        onChange={(event) => handleChange(event, layoutComponent.apiName)}
                        value={fieldValue}
                        required={layoutItem.required}
                        disabled={(state.Id.length > 0)}
                        type={inputType}
                        sx={{width: "100%"}}
                    />
                );
                break;
            case 'TEXTAREA':
            case 'TextArea':
                fieldElement = (
                    <MDInput
                        label={layoutItem.label}
                        onChange={(event) => handleChange(event, layoutComponent.apiName)}
                        value={fieldValue}
                        required={layoutItem.required}
                        disabled={(state.Id.length > 0)}
                        multiline
                        rows={3}
                        sx={{width: "100%"}}
                    />
                );
                break;
            case 'PICKLIST':
            case 'Picklist':
                fieldElement = (
                    <MDSelect
                        label={layoutItem.label}
                        options={fieldOptions}
                        onChange={(event, newValue) => onSelectChange(newValue, layoutComponent.apiName)}
                        value={fieldValue}
                        required={layoutItem.required}
                        disabled={(state.Id.length > 0)}
                        sx={{width: "100%"}}
                    />
                );
                break;
            case 'Reference':
                fieldElement = (
                    <MDSelect
                        label={layoutItem.label}
                        options={fieldOptions}
                        onChange={(event, newValue) => onSelectChange(newValue, layoutComponent.apiName)}
                        value={fieldValue}
                        required={layoutItem.required}
                        disabled={(state.Id.length > 0)}
                        sx={{width: "100%"}}
                    />
                );
                break;
            default:
                break;
        }
        return fieldElement;
    }
    function handleSubmit(){
        const { layout, objectInfo } = state;
        if(layout === null || objectInfo === null){
            return;
        }
        const fields = objectInfo.fields;
        const requestData = {};
        layout.sections.map((section) => {
            section.layoutRows.map((row) => {
                row.layoutItems.map((layoutItem) => {
                    const layoutComponent = layoutItem.layoutComponents[0];
                    let apiName = layoutComponent.apiName;
                    if(layoutComponent.componentType !== 'Field'){
                        return null;
                    }
                    if(!layoutItem.editableForNew){
                        return null;
                    }
                    let field = null;
                    if(layoutComponent.componentType === 'Field' && fields.hasOwnProperty(layoutComponent.apiName)){
                        field = fields[layoutComponent.apiName];
                    }
                    if(field && field.dataType === "Reference"){
                        requestData[apiName] = state[apiName+"Selection"];
                    }else{
                        requestData[apiName] = state[apiName];
                    }
                    return null;
                });
                return null;
            });
            return null;
        });

        const url = "/sobjects/"+objectType;
        Api.standardApiPost(url, requestData).then((response) => {
            setState({
                successMessage: objectType+" has been created."
            });
        }).catch(err => {
            console.log(err);
        });

        console.log("requestData", requestData);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                {
                    loading ?
                        <Loader p={2} color="info" />
                    :
                    renderLayout()
                }
                {
                    loading === false ?
                        <div style={{marginTop: "16px"}}>
                            {
                                state.successMessage !== null ?
                                    <p className="slds-text-color_success slds-m-bottom_small">{state.successMessage}</p>
                                :
                                    null
                            }
                            <MDButton key="save" variant="gradient" color="info" onClick={handleSubmit}>
                                Save
                            </MDButton>
                        </div>
                    :
                    null
                }
            </MDBox>
        </DashboardLayout>
    )
}

export default UIApi;